export enum Buttons {
  NEXT = 'Next',
}
